import Image from "next/image";
import React from 'react'
import styles from "./tnpsc-workshop.module.css";
import Banner from "../../assets/images/Tnpsc/TNPSC-Workshop-Based-Web-Banner.jpg";
import MobBanner from "../../assets/images/Tnpsc/TNPSC-Workshop-Based-Mobile-Banner.jpg";
import youtube_thumnail_1 from "../../assets/images/Tnpsc/MCP_TEST_SERIES.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';
import Head from 'next/head';

import { useState } from "react";

const Tnpsc_gr_IV_testbatch = () => {

  const [play, setPlay] = useState(false);


const feestructure3 = [
  {
    center: "Anna Nagar",
    fee: {
      
      old: "All Student : ₹35,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline Only",
        start: "27-08-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-MCP-Test-Serie-2027/Anna-nagar/Tnpsc-MCP-Test-Series-B1-AnnaNagar.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC",
      },

    ],
  },

]




    return (
        <>

        <Head>
            <meta charset="UTF-8" />  
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Workshop Based Mains Cum Prelims Test Series 2027 | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Workshop Based Mains Cum Prelims Test Series 2027 | Shankar IAS Academy" />
            <meta name="description" content="Join the TNPSC Workshop Based Mains Cum Prelims Test Series 2027 at Shankar IAS Academy. Expert mentoring, structured classes, tests, evaluation, and complete exam preparation." />
            <meta name="keywords" content="TNPSC Workshop Based Mains Cum Prelims Test Series,TNPSC Test Series 2027,TNPSC Mains Test Series,TNPSC Prelims Test Series,TNPSC Coaching,TNPSC Classes,TNPSC Mock Test,TNPSC Exam Preparation,Shankar IAS Academy TNPSC,TNPSC Workshop Programme"></meta>
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-workshop-based-mains-prelims-test-series/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Workshop Based Mains Cum Prelims Test Series 2027 | Shankar IAS Academy" />
            <meta property="og:description" content="Join the TNPSC Workshop Based Mains Cum Prelims Test Series 2027 at Shankar IAS Academy. Expert mentoring, structured classes, tests, evaluation, and complete exam preparation." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-workshop-based-mains-prelims-test-series/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

          <Navbar title="tnpsc" />

          <div className="container">
                <div className="pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Workshop Based Mains Cum Prelims Test Series 2027</h1>
                </div>
          </div>

          <div className="container pb-4">

                  <div className="row d-none d-md-block">
                      <div className="col pt-3 pt-md-2">
                          <Image src={Banner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group IV Prelims Test" className="img-fluid w-100"/>
                      </div>
                  </div>

                  <div className="row d-block d-md-none">
                      <div className="col pt-3 pt-md-5">
                          <Image src={MobBanner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group IV Prelims Test" className="img-fluid w-100"/>
                      </div>
                  </div> 
          </div>

    <div
      className="container-fluid py-4 py-md-5"
      style={{ background: "linear-gradient(135deg, #f4f6f8, #eaf0f5)", }}
      >
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 col-xl-10">
          <div className={styles.featuresCard}>
            {/* Heading */}
            <div className="row">
              <div className="col-12">
                <h2 className={`${styles.sectionTitle} `}>
                  Why <span style={{color:"#061569"}}> WORKSHOP-BASED MCP </span> Test Series at Shankar IAS Academy?
                </h2>
              </div>
            </div>

            {/* Features */}
            <div className="row g-4 g-md-5">
              <div className="col-12 col-md-6">
                <ul className={styles.featureList}>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                      <b>Integrated Preparation Strategy</b> : A Mains-cum-Prelims Test Series lets you prepare for both stages side by side, practise consistently, and work on your weak areas as you progress.
                    </span>
                  </li>
                 
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                      <b>Foundation & Strategy Workshops:</b> Know what to study, how to study and how to approach the exam right from Day 1.
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                     <b>Dedicated Mains Notes Preparation Workshops:</b>Instead of collecting endless material, learn to prepare your own crisp, useful revision notes that you can actually rely on before the exam.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Right Column */}
              <div className="col-12 col-md-6">
                <ul className={styles.featureList}>

                   <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                      <b>64+ Mains Tests:</b>Write regularly, get your answers evaluated, understand where you’re going wrong and keep improving with every test.
                    </span>
                  </li>


                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                     <b>40+ Prelims Tests:</b> TNPSC Prelims Test Series will help you to manage time under exam pressure and find your weak areas to improve.   
                    </span>
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                     <b>PYQ Analysis for both Mains & Prelims: </b> Understand the PYQ pattern, identify what matters and align your preparation accordingly.
                    </span>
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                     <b>ONE-ON-ONE Mentoring & Evaluation: </b> Get personal guidance, honest feedback and continuous direction to keep improving.

                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section className={styles.courseSection}>
      <div className="container">
        <div className={styles.headingBox}>
          <h3> TNPSC  Mains Cum Prelims Test Series 2027</h3>             
        </div>

        <div className={`${styles.tableWrapper} d-none d-md-block`}>
          <table className={styles.courseTable}>
            <thead>
              <tr>
                <th>Center</th>
                <th>Batch</th>
                <th>Starts On</th>
                <th>Fee</th>
                <th>Schedule</th>
                <th>Admission</th>
              </tr>
            </thead>

            <tbody >
              {feestructure3.map((centerItem) =>
                centerItem.batches.map((batch, index) => (
                  <tr key={index}>
                    {index === 0 && (
                      <td rowSpan={centerItem.batches.length}>
                         {centerItem.center}
                      </td>
                    )}

                    <td>{batch.batch}</td>

                    <td>{batch.start}</td>

                    <td>
                      <div>{centerItem.fee.new}</div>
                      <div>{centerItem.fee.old}</div>
                    </td>

                    <td>
                      {batch.schedule !== "#" ? (
                        <a href={batch.schedule} target="_blank">
                           <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                            View Pdf
                        </a>
                        ) : (
                        <span>Update Soon</span>
                      )}
                    </td>

                    <td>
                      {batch.admission !== "#" ? (
                        <a href={batch.admission} target="_blank">
                          <button className={styles.payBtn}>
                            Pay Now
                          </button>
                         </a>
                        ) : (
                          <span style={{color: "#002efc" }}>Admissions Closed</span>
                        )}
                    </td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div  className={`${styles.mobileView} d-block d-md-none`}>
          {feestructure3.map((centerItem, centerIndex) =>
            centerItem.batches.map((batch, index) => (
            <div className={styles.card} key={index}>                  
              <div className={styles.row}>
                <span>Center</span>
                <strong>{centerItem.center}</strong>
              </div>

              <div className={styles.row}>
                {/* <span>Batch</span> */}
                <strong>{batch.batch}</strong>
              </div>

              <div className={styles.row}>
                <span>Start Date</span>
                <strong>{batch.start}</strong>
              </div>

              <div className={styles.row}>
                <span>Fee</span>
                <strong>{centerItem.fee.new}</strong>
              </div>

              <div className={styles.row}>
                <span>Old Fee</span>
                <small>{centerItem.fee.old}</small>
              </div>

              <div className={styles.actions}>
                <span>Schedule</span>
                  {batch.schedule !== "#" ? (
                  <a href={batch.schedule} target="_blank">
                    View
                  </a>
                  ) : (
                 <span>Update Soon</span>
                  )}
              </div>

              <div className={styles.actions}>
                <span>Schedule</span>
                  {batch.admission !== "#" ? (
                    <a href={batch.admission} target="_blank">
                     <button className={styles.payBtn}>
                        Pay Now
                      </button>
                    </a>
                  ) : (
                  <span style={{color: "#002efc" }}>Admissions Closed</span>
                )}                           
              </div>
            </div>
            ))
          )}
        </div>
      </div>
    </section>	

    <div className="container-fluid py-4 py-md-5" style={{ background: "linear-gradient(135deg, #d9eafc, #eaf0f5)", }} >
        <div className={styles.headingBox}>
          <h3> MCP Test Series: Features, Benefits & Complete Details</h3>             
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-lg-6 my-md-3 px-xl-3 bg-white shadow-lg rounded-4 p-3 p-md-5">
              {play ? (
                <iframe
                  src="https://www.youtube.com/embed/4TwOMUT6A00"
                  className="w-100"
                  style={{
                    height: "350px",
                    border: "0",
                  }}
                  title="MCP Test Series"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <Image
                  src={youtube_thumnail_1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setPlay(true)}
                  className="img-fluid w-100"
                  alt="MCP Test Series"
                />
              )}
          </div>
        </div>
    </div>
        
    <Footer />

    </>
  )
}

export default Tnpsc_gr_IV_testbatch;